import { useState, useEffect } from "react";

const G = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,800;0,900;1,700&family=Inter:wght@300;400;500;600;700;800&display=swap');
    *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
    html, body { overflow:hidden; height:100%; }
    @keyframes fadeUp  { from{opacity:0;transform:translateY(18px)} to{opacity:1;transform:translateY(0)} }
    @keyframes slideL  { from{opacity:0;transform:translateX(-28px)} to{opacity:1;transform:translateX(0)} }
    @keyframes slideR  { from{opacity:0;transform:translateX(28px)}  to{opacity:1;transform:translateX(0)} }
    @keyframes scaleIn { from{opacity:0;transform:scale(0.82)} to{opacity:1;transform:scale(1)} }
    @keyframes pulse   { 0%,100%{opacity:1} 50%{opacity:.35} }
    @keyframes barGrow { from{width:0} to{width:var(--bw,100%)} }
    ::-webkit-scrollbar { display:none; }
    button:focus { outline:none; }
    @media(min-width:768px){
      body { font-size:16px; }
    }
  `}</style>
);

function A({children,delay=0,dir="up",style={}}) {
  const [v,setV]=useState(false);
  useEffect(()=>{const t=setTimeout(()=>setV(true),delay);return()=>clearTimeout(t);},[delay]);
  const an={left:"slideL",right:"slideR",scale:"scaleIn"}[dir]||"fadeUp";
  return <div style={{opacity:v?1:0,animation:v?`${an} 0.5s cubic-bezier(0.23,1,0.32,1) both`:"none",...style}}>{children}</div>;
}

const GOLD="#C9A84C"; const NAVY="#06091A";

const Slide=({children,bg="#FAFAF8",style={}})=>(
  <div style={{minHeight:"100vh",background:bg,display:"flex",flexDirection:"column",
    padding:"32px 32px 80px",position:"relative",overflow:"hidden",...style}}>
    {children}
  </div>
);

const Tag=({children,color,delay=40})=>(
  <A delay={delay}>
    <div style={{display:"inline-flex",alignItems:"center",gap:7,marginBottom:11}}>
      <div style={{width:16,height:2,background:color,borderRadius:2}}/>
      <span style={{fontSize:13,fontWeight:700,letterSpacing:"2px",textTransform:"uppercase",color}}>{children}</span>
    </div>
  </A>
);

const H=({children,delay=90,style={}})=>(
  <A delay={delay}>
    <div style={{fontFamily:"'Playfair Display',serif",fontSize:"clamp(26px,4.5vw,36px)",
      fontWeight:900,lineHeight:1.08,letterSpacing:"-0.8px",color:"#0A0F1E",...style}}>
      {children}
    </div>
  </A>
);

const Div=({delay=180,color=GOLD})=>(
  <A delay={delay}><div style={{width:24,height:2,background:color,borderRadius:2,marginBottom:14}}/></A>
);

const Bullet=({children,color="#374151",dot="#6B7280",size=13})=>(
  <div style={{display:"flex",gap:8,alignItems:"flex-start",marginBottom:7}}>
    <div style={{width:6,height:6,borderRadius:"50%",background:dot,flexShrink:0,marginTop:4}}/>
    <span style={{fontSize:size,color,lineHeight:1.65}}>{children}</span>
  </div>
);

const SubBullet=({children})=>(
  <div style={{display:"flex",gap:7,alignItems:"flex-start",marginBottom:4,paddingLeft:16}}>
    <div style={{width:4,height:4,borderRadius:"50%",background:"#9CA3AF",flexShrink:0,marginTop:3.5}}/>
    <span style={{fontSize:14,color:"#6B7280",lineHeight:1.6}}>{children}</span>
  </div>
);

const Card=({children,color="#2563EB",delay=0,style={}})=>(
  <A delay={delay}>
    <div style={{background:"#fff",borderRadius:14,padding:"16px 18px",
      border:`1px solid ${color}18`,borderTop:`3px solid ${color}`,
      boxShadow:"0 2px 10px rgba(0,0,0,.05)",...style}}>
      {children}
    </div>
  </A>
);

const InfoBox=({children,color=GOLD,delay=400})=>(
  <A delay={delay}>
    <div style={{background:`${color}0D`,border:`1px solid ${color}30`,
      borderRadius:10,padding:"11px 14px",marginTop:12}}>
      <span style={{fontSize:15,color,lineHeight:1.7}}>{children}</span>
    </div>
  </A>
);

const SectionHeader=({tag,tagColor,title,sub,dark=false})=>(
  <div style={{background:dark?`linear-gradient(135deg,${NAVY},#0D1530)`:"#fff",
    borderRadius:14,padding:"16px 18px",marginBottom:14,
    border:`1px solid ${dark?"rgba(255,255,255,.08)":"#E5EAF0"}`}}>
    <div style={{fontSize:10,fontWeight:800,letterSpacing:"2px",textTransform:"uppercase",
      color:dark?"rgba(255,255,255,.4)":tagColor,marginBottom:6}}>{tag}</div>
    <div style={{fontFamily:"'Playfair Display',serif",fontSize:17,fontWeight:900,
      color:dark?"#fff":"#0A0F1E",lineHeight:1.15,marginBottom:sub?5:0}}>{title}</div>
    {sub&&<div style={{fontSize:13,color:dark?"rgba(255,255,255,.45)":"#6B7280",lineHeight:1.6}}>{sub}</div>}
  </div>
);

/* ══ SLIDES ══ */

function S00_Agenda() {
  const part1 = [
    {time:"0:00", topic:"Welcome & Introductions",     color:"#2563EB", icon:"👋"},
    {time:"2:00", topic:"What is USMLE & the IMG Roadmap", color:"#6366F1", icon:"🗺️"},
    {time:"7:00", topic:"What is Step 1 — New 2026 Format", color:"#059669", icon:"📋"},
    {time:"12:00",topic:"Our 120-Day Program Structure",  color:GOLD,    icon:"📅"},
    {time:"18:00",topic:"Starting as a Graduate",         color:"#7C3AED", icon:"🎓"},
    {time:"22:00",topic:"Registration & Fees",            color:"#E05252", icon:"📝"},
    {time:"26:00",topic:"Resources — What to Use",        color:"#0891B2", icon:"📚"},
    {time:"30:00",topic:"UWorld Strategy — Our Approach", color:"#2563EB", icon:"❓"},
    {time:"36:00",topic:"Question Solving & Review Strategy", color:"#F59E0B", icon:"🧠"},
    {time:"40:00",topic:"Self-Assessments & Timeline",    color:"#7C3AED", icon:"📊"},
    {time:"44:00",topic:"Exam Day & Dedicated Period",    color:"#E05252", icon:"🏥"},
    {time:"44:30",topic:"FAQ & Open Q&A",                 color:"#059669", icon:"💬"},
  ];
  return (
    <div style={{minHeight:"100vh",background:`linear-gradient(160deg,${NAVY} 0%,#080E20 55%,#0D1530 100%)`,
      display:"flex",flexDirection:"column",position:"relative",overflow:"hidden"}}>
      <div style={{position:"absolute",inset:0,backgroundImage:`radial-gradient(rgba(201,168,76,.06) 1px,transparent 1px)`,backgroundSize:"26px 26px",pointerEvents:"none"}}/>
      <div style={{position:"absolute",top:-60,right:-60,width:300,height:300,borderRadius:"50%",
        background:`radial-gradient(circle,rgba(201,168,76,.1) 0%,transparent 65%)`,pointerEvents:"none"}}/>

      {/* Nav bar */}
      <div style={{padding:"18px 26px",borderBottom:"1px solid rgba(255,255,255,.07)",
        display:"flex",alignItems:"center",justifyContent:"space-between",position:"relative",zIndex:1}}>
        <div style={{display:"flex",alignItems:"center",gap:9}}>
          <div style={{width:28,height:28,borderRadius:8,background:`linear-gradient(135deg,${GOLD},#A8862E)`,
            display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Playfair Display',serif",
            fontSize:15,fontWeight:700,color:NAVY,fontStyle:"italic"}}>U</div>
          <span style={{fontFamily:"'Playfair Display',serif",fontStyle:"italic",fontSize:".88rem",color:"rgba(255,255,255,.8)"}}>USMLE Corner</span>
        </div>
        <span style={{fontSize:10,color:"rgba(255,255,255,.25)",letterSpacing:"1.5px",textTransform:"uppercase"}}>Orientation Session · June 2025</span>
      </div>

      <div style={{flex:1,padding:"20px 26px 16px",position:"relative",zIndex:1,overflow:"auto"}}>
        <A delay={60}>
          <div style={{fontSize:10,fontWeight:700,letterSpacing:"3px",textTransform:"uppercase",color:GOLD,opacity:.8,marginBottom:10}}>
            Today's Session
          </div>
        </A>
        <A delay={120}>
          <div style={{fontFamily:"'Playfair Display',serif",fontSize:"clamp(22px,5vw,32px)",
            fontWeight:900,lineHeight:1.05,letterSpacing:"-1px",color:"#fff",marginBottom:6}}>
            What we'll<br/><span style={{fontStyle:"italic",color:GOLD}}>cover today.</span>
          </div>
        </A>
        <A delay={180}><div style={{width:24,height:2,background:GOLD,borderRadius:2,marginBottom:16}}/></A>

        {/* Two parts row */}
        <A delay={220}>
          <div style={{display:"flex",gap:10,marginBottom:16}}>
            <div style={{flex:3,background:"rgba(255,255,255,.06)",border:"1px solid rgba(255,255,255,.1)",
              borderRadius:12,padding:"10px 14px",borderTop:`2px solid ${GOLD}`}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:3}}>
                <div style={{fontSize:14,fontWeight:800,color:"#fff"}}>Part 1 — Orientation</div>
                <div style={{background:`${GOLD}20`,border:`1px solid ${GOLD}40`,borderRadius:99,
                  padding:"2px 10px",fontSize:12,fontWeight:800,color:GOLD}}>45 min</div>
              </div>
              <div style={{fontSize:12,color:"rgba(255,255,255,.4)"}}>Full Step 1 guide · Resources · Strategy · Exam day</div>
            </div>
            <div style={{flex:1.5,background:"rgba(255,255,255,.06)",border:"1px solid rgba(255,255,255,.1)",
              borderRadius:12,padding:"10px 14px",borderTop:"2px solid #2563EB"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:3}}>
                <div style={{fontSize:14,fontWeight:800,color:"#fff"}}>Part 2</div>
                <div style={{background:"rgba(37,99,235,.2)",border:"1px solid rgba(37,99,235,.4)",borderRadius:99,
                  padding:"2px 10px",fontSize:12,fontWeight:800,color:"#60A5FA"}}>15 min</div>
              </div>
              <div style={{fontSize:12,color:"rgba(255,255,255,.4)"}}>LMS walkthrough</div>
            </div>
          </div>
        </A>

        {/* Agenda list */}
        <div style={{display:"flex",flexDirection:"column",gap:4}}>
          {part1.map((item,i)=>(
            <A key={i} delay={260+i*40} dir="right">
              <div style={{display:"flex",alignItems:"center",gap:10,
                padding:"7px 11px",borderRadius:9,
                background:"rgba(255,255,255,.04)",
                border:"1px solid rgba(255,255,255,.06)",
                borderLeft:`2.5px solid ${item.color}`}}>
                <div style={{fontFamily:"'DM Mono',monospace",fontSize:10,color:"rgba(255,255,255,.3)",
                  width:34,flexShrink:0}}>{item.time}</div>
                <span style={{fontSize:10}}>  {item.icon}</span>
                <div style={{fontSize:13,fontWeight:600,color:"rgba(255,255,255,.78)",flex:1,lineHeight:1.3}}>{item.topic}</div>
              </div>
            </A>
          ))}
        </div>

        {/* LMS part */}
        <A delay={800}>
          <div style={{marginTop:10,display:"flex",alignItems:"center",gap:10,
            padding:"10px 14px",borderRadius:10,
            background:"rgba(37,99,235,.1)",border:"1px solid rgba(37,99,235,.25)",
            borderLeft:"2.5px solid #2563EB"}}>
            <div style={{fontFamily:"'DM Mono',monospace",fontSize:10,color:"rgba(255,255,255,.3)",width:34,flexShrink:0}}>45:00</div>
            <span style={{fontSize:10}}>💻</span>
            <div>
              <div style={{fontSize:13,fontWeight:700,color:"rgba(255,255,255,.85)"}}>LMS Walkthrough</div>
              <div style={{fontSize:12,color:"rgba(255,255,255,.35)",marginTop:1}}>Dashboard · Study plan · How to use daily · QID copy · Progress tracking</div>
            </div>
            <div style={{background:"rgba(37,99,235,.2)",border:"1px solid rgba(37,99,235,.35)",borderRadius:99,
              padding:"2px 10px",fontSize:12,fontWeight:800,color:"#60A5FA",flexShrink:0}}>15 min</div>
          </div>
        </A>
      </div>

      <div style={{padding:"12px 26px",borderTop:"1px solid rgba(255,255,255,.06)",
        display:"flex",justifyContent:"space-between",position:"relative",zIndex:1}}>
        <span style={{fontSize:10,color:"rgba(255,255,255,.2)",letterSpacing:"1px"}}>lms.usmlecorner.com</span>
        <span style={{fontSize:10,color:"rgba(255,255,255,.2)"}}>Total: 60 minutes</span>
      </div>
    </div>
  );
}

function S01b_Team() {
  const team = [
    {
      name:"Dr. Ali",
      role:"Course Coordinator & Lead Mentor",
      tags:["Course Director","Step 1 Tutor","Step 2 CK Tutor","Lead Mentor"],
      color:GOLD,
      initial:"A",
      note:"Your primary point of contact. Oversees the full program, curriculum, and your progress."
    },
    {
      name:"Dr. Hasham",
      role:"Step 1 & Step 2 CK Tutor · Mentor",
      tags:["Step 1 Tutor","Step 2 CK Tutor","Mentor"],
      color:"#2563EB",
      initial:"H",
      note:""
    },
    {
      name:"Dr. Kumar",
      role:"Step 1 Tutor",
      tags:["Step 1 Tutor","UWorld Strategy"],
      color:"#059669",
      initial:"K",
      note:"Focused on high-yield concept delivery and UWorld question walkthroughs."
    },
    {
      name:"Dr. Imran",
      role:"Step 1 & Step 2 CK Tutor · Mentor",
      tags:["Step 1 Tutor","Step 2 CK Tutor","Mentor"],
      color:"#7C3AED",
      initial:"I",
      note:""
    },
    {
      name:"Dr. Ikram",
      role:"Step 1 & Step 2 CK Tutor · Mentor",
      tags:["Step 1 Tutor","Step 2 CK Tutor","Mentor"],
      color:"#E05252",
      initial:"Ik",
      note:""
    },
    {
      name:"Dr. KC Anas",
      role:"Step 1 Tutor · US Resident",
      tags:["Step 1 Tutor","PGY-1 Resident","UT Health San Antonio"],
      color:"#0891B2",
      initial:"KC",
      note:"First-year resident at UT Health San Antonio. Real-world clinical insight into Step 1 prep."
    },
  ];

  return (
    <div style={{minHeight:"100vh",background:"#FAFAF8",
      display:"flex",flexDirection:"column",position:"relative",overflow:"hidden"}}>
      <div style={{position:"absolute",inset:0,backgroundImage:`radial-gradient(rgba(201,168,76,.1) 1px,transparent 1px)`,backgroundSize:"28px 28px",pointerEvents:"none"}}/>
      <div style={{position:"absolute",top:-60,right:-60,width:300,height:300,borderRadius:"50%",
        background:`radial-gradient(circle,rgba(201,168,76,.08) 0%,transparent 65%)`,pointerEvents:"none"}}/>

      {/* Nav */}
      <div style={{padding:"18px 28px",borderBottom:"1px solid rgba(0,0,0,.07)",
        display:"flex",alignItems:"center",justifyContent:"space-between",position:"relative",zIndex:1}}>
        <div style={{display:"flex",alignItems:"center",gap:9}}>
          <div style={{width:28,height:28,borderRadius:8,background:`linear-gradient(135deg,${GOLD},#A8862E)`,
            display:"flex",alignItems:"center",justifyContent:"center",
            fontFamily:"'Playfair Display',serif",fontSize:15,fontWeight:700,color:NAVY,fontStyle:"italic"}}>U</div>
          <span style={{fontFamily:"'Playfair Display',serif",fontStyle:"italic",fontSize:15,color:NAVY}}>USMLE Corner</span>
        </div>
        <span style={{fontSize:11,color:"#9CA3AF",letterSpacing:"1.5px",textTransform:"uppercase"}}>Batch June 2025</span>
      </div>

      <div style={{flex:1,padding:"22px 28px 16px",position:"relative",zIndex:1,overflow:"auto"}}>
        <A delay={60}>
          <div style={{fontSize:11,fontWeight:700,letterSpacing:"3px",textTransform:"uppercase",
            color:"#9B7A20",marginBottom:10}}>Your Team</div>
        </A>
        <A delay={120}>
          <div style={{fontFamily:"'Playfair Display',serif",fontSize:"clamp(24px,5vw,34px)",
            fontWeight:900,lineHeight:1.05,letterSpacing:"-1px",color:NAVY,marginBottom:6}}>
            The people behind<br/><span style={{fontStyle:"italic",color:GOLD}}>your success.</span>
          </div>
        </A>
        <A delay={180}><div style={{width:24,height:2.5,background:GOLD,borderRadius:2,marginBottom:20}}/></A>

        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          {team.map((m,i)=>(
            <A key={i} delay={220+i*80} dir={i%2===0?"left":"right"}>
              <div style={{background:"#fff",border:"1px solid #E5EAF0",
                borderLeft:`3px solid ${m.color}`,borderRadius:13,padding:"14px 16px",
                display:"flex",gap:14,alignItems:"flex-start",boxShadow:"0 2px 10px rgba(0,0,0,.05)"}}>

                {/* Avatar */}
                <div style={{width:44,height:44,borderRadius:12,flexShrink:0,
                  background:`linear-gradient(135deg,${m.color},${m.color}99)`,
                  display:"flex",alignItems:"center",justifyContent:"center",
                  fontFamily:"'Playfair Display',serif",fontSize:16,fontWeight:900,
                  color:"#fff",boxShadow:`0 4px 14px ${m.color}40`}}>
                  {m.initial}
                </div>

                {/* Info */}
                <div style={{flex:1,minWidth:0}}>
                  <div style={{display:"flex",alignItems:"baseline",gap:8,marginBottom:3,flexWrap:"wrap"}}>
                    <div style={{fontSize:16,fontWeight:800,color:NAVY,fontFamily:"'Playfair Display',serif",
                      fontStyle:"italic"}}>{m.name}</div>
                  </div>
                  <div style={{fontSize:11,color:m.color,fontWeight:600,marginBottom:6,lineHeight:1.3}}>{m.role}</div>
                  {/* Tags */}
                  <div style={{display:"flex",flexWrap:"wrap",gap:4,marginBottom:6}}>
                    {m.tags.map((t,j)=>(
                      <span key={j} style={{fontSize:10,fontWeight:700,
                        background:`${m.color}18`,color:m.color,
                        border:`1px solid ${m.color}30`,borderRadius:99,
                        padding:"2px 9px"}}>{t}</span>
                    ))}
                  </div>
                  {m.note && <div style={{fontSize:11,color:"#9CA3AF",lineHeight:1.55}}>{m.note}</div>}
                </div>
              </div>
            </A>
          ))}
        </div>
      </div>

      <div style={{padding:"12px 28px",borderTop:"1px solid rgba(0,0,0,.07)",
        position:"relative",zIndex:1,display:"flex",justifyContent:"space-between"}}>
        <span style={{fontSize:10,color:"#9CA3AF",letterSpacing:"1px"}}>lms.usmlecorner.com</span>
        <span style={{fontSize:10,color:"#9CA3AF"}}>6 faculty · Available daily</span>
      </div>
    </div>
  );
}

function S01_Cover() {
  return (
    <div style={{minHeight:"100vh",background:`linear-gradient(160deg,${NAVY} 0%,#080E20 55%,#0D1530 100%)`,
      display:"flex",flexDirection:"column",position:"relative",overflow:"hidden"}}>
      <div style={{position:"absolute",inset:0,backgroundImage:`radial-gradient(rgba(201,168,76,.07) 1px,transparent 1px)`,backgroundSize:"26px 26px",pointerEvents:"none"}}/>
      <div style={{position:"absolute",top:-60,right:-60,width:320,height:320,borderRadius:"50%",
        background:`radial-gradient(circle,rgba(201,168,76,.12) 0%,transparent 65%)`,pointerEvents:"none"}}/>

      <div style={{padding:"20px 26px",borderBottom:"1px solid rgba(255,255,255,.07)",
        display:"flex",alignItems:"center",justifyContent:"space-between",position:"relative",zIndex:1}}>
        <div style={{display:"flex",alignItems:"center",gap:9}}>
          <div style={{width:30,height:30,borderRadius:8,background:`linear-gradient(135deg,${GOLD},#A8862E)`,
            display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Playfair Display',serif",
            fontSize:16,fontWeight:700,color:NAVY,fontStyle:"italic"}}>U</div>
          <span style={{fontFamily:"'Playfair Display',serif",fontStyle:"italic",fontSize:".9rem",color:"rgba(255,255,255,.85)"}}>USMLE Corner</span>
        </div>
        <span style={{fontSize:10,color:"rgba(255,255,255,.25)",letterSpacing:"1.5px",textTransform:"uppercase"}}>Batch Orientation · June 2025</span>
      </div>

      <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",
        padding:"36px 26px",textAlign:"center",position:"relative",zIndex:1}}>
        <A delay={80}><div style={{fontSize:10,fontWeight:700,letterSpacing:"3px",textTransform:"uppercase",color:GOLD,marginBottom:18,opacity:.8}}>Welcome · New Batch · June 1, 2025</div></A>
        <A delay={160}>
          <div style={{fontFamily:"'Playfair Display',serif",fontSize:"clamp(30px,7vw,48px)",
            fontWeight:900,lineHeight:1.0,letterSpacing:"-2px",color:"#fff",marginBottom:14}}>
            Your Step 1<br/><span style={{fontStyle:"italic",color:GOLD}}>Journey Starts</span><br/>Today.
          </div>
        </A>
        <A delay={260}><div style={{width:32,height:2.5,background:GOLD,borderRadius:2,margin:"0 auto 18px"}}/></A>
        <A delay={320}>
          <p style={{fontSize:15,color:"rgba(255,255,255,.38)",lineHeight:1.8,maxWidth:300,marginBottom:28}}>
            A complete guide to everything you need to know — resources, UWorld strategy, assessments, and exam day.
          </p>
        </A>
        <A delay={400}>
          <div style={{background:"rgba(255,255,255,.05)",border:"1px solid rgba(255,255,255,.1)",
            borderRadius:12,padding:"13px 22px",textAlign:"center"}}>
            <div style={{fontFamily:"'Playfair Display',serif",fontSize:20,fontWeight:700,color:GOLD}}>Dr. Ali</div>
            <div style={{fontSize:10,color:"rgba(255,255,255,.3)",letterSpacing:"1.5px",textTransform:"uppercase",marginTop:3}}>Lead Tutor · USMLE Corner</div>
          </div>
        </A>
      </div>

      <div style={{padding:"16px 26px",borderTop:"1px solid rgba(255,255,255,.06)",
        display:"flex",justifyContent:"space-between",position:"relative",zIndex:1}}>
        <span style={{fontSize:10,color:"rgba(255,255,255,.2)",letterSpacing:"1px"}}>lms.usmlecorner.com</span>
        <span style={{fontSize:10,color:"rgba(255,255,255,.2)"}}>← → or arrow keys to navigate</span>
      </div>
    </div>
  );
}

function S02_WhatIsUSMLE() {
  const roadmap = [
    {label:"Step 1",sub:"Basic Sciences",color:"#E05252",shape:"circle"},
    {label:"Step 2 CK",sub:"Clinical Knowledge",color:"#2563EB",shape:"circle"},
    {label:"OET",sub:"English Test",color:"#D97706",shape:"circle"},
    {label:"Step 3",sub:"Optional",color:"#7C3AED",shape:"circle"},
    {label:"NRMP",sub:"The Match",color:"#059669",shape:"circle"},
  ];
  const adjuncts = [
    {label:"Research",color:"#6366F1"},
    {label:"USCE",sub:"Electives · Observerships · Externships",color:"#0891B2"},
    {label:"ECAs",color:"#EC4899"},
  ];
  return (
    <Slide>
      <Tag color="#2563EB">Introduction</Tag>
      <H>What is the <span style={{color:"#2563EB"}}>USMLE?</span></H>
      <Div color="#2563EB"/>
      <A delay={160}>
        <p style={{fontSize:14,color:"#374151",lineHeight:1.75,marginBottom:14}}>
          The USMLE® is a three-step examination providing one standardized pathway to obtain medical licensure in the United States. International medical graduates (IMGs) also need the <strong>OET</strong> and <strong>ECFMG certification</strong> to be eligible for residency.
        </p>
      </A>

      {/* Roadmap */}
      <A delay={220}>
        <div style={{fontSize:10,fontWeight:700,letterSpacing:"2px",textTransform:"uppercase",color:"#9CA3AF",marginBottom:10}}>The IMG Roadmap</div>
      </A>
      <A delay={280}>
        <div style={{background:"#fff",borderRadius:14,padding:"16px 14px",border:"1px solid #E5EAF0",boxShadow:"0 2px 10px rgba(0,0,0,.05)",marginBottom:12}}>
          {/* Main path */}
          <div style={{display:"flex",alignItems:"center",gap:0,marginBottom:14,position:"relative"}}>
            <div style={{position:"absolute",top:"50%",left:0,right:0,height:2,
              background:"linear-gradient(90deg,#E05252,#2563EB,#D97706,#7C3AED,#059669)",
              opacity:.25,transform:"translateY(-50%)",zIndex:0}}/>
            {roadmap.map((r,i)=>(
              <div key={i} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",gap:6,position:"relative",zIndex:1}}>
                <div style={{width:34,height:34,borderRadius:"50%",background:r.color,
                  display:"flex",alignItems:"center",justifyContent:"center",
                  boxShadow:`0 2px 8px ${r.color}40`,border:"2px solid #fff"}}>
                  <span style={{fontSize:10,fontWeight:800,color:"#fff",textAlign:"center",lineHeight:1.1,padding:"0 2px"}}>{r.label}</span>
                </div>
                <div style={{fontSize:10,color:r.color,fontWeight:700,textAlign:"center",lineHeight:1.2}}>{r.sub}</div>
              </div>
            ))}
          </div>
          {/* Adjuncts */}
          <div style={{borderTop:"1px dashed #E5EAF0",paddingTop:10}}>
            <div style={{fontSize:10,fontWeight:700,letterSpacing:"1.5px",textTransform:"uppercase",color:"#9CA3AF",marginBottom:7,textAlign:"center"}}>Adjuncts (alongside the pathway)</div>
            <div style={{display:"flex",gap:8,justifyContent:"center"}}>
              {adjuncts.map((a,i)=>(
                <div key={i} style={{background:`${a.color}10`,border:`1px solid ${a.color}30`,
                  borderRadius:8,padding:"6px 10px",textAlign:"center"}}>
                  <div style={{fontSize:12,fontWeight:800,color:a.color}}>{a.label}</div>
                  {a.sub&&<div style={{fontSize:10,color:"#9CA3AF",marginTop:2}}>{a.sub}</div>}
                </div>
              ))}
            </div>
          </div>
        </div>
      </A>

      <A delay={420}>
        <p style={{fontSize:14,color:"#374151",lineHeight:1.75}}>
          Keep in mind that the Steps are just one component of your profile. Other requirements include your medical school degree, transcripts, research work, <strong>USCE</strong> (electives, observerships, externships), and extracurricular activities (ECAs).
        </p>
      </A>
    </Slide>
  );
}

function S03_WhatIsStep1() {
  const disciplines = [
    ["Pathology","44–52%","#E05252",52],
    ["Physiology","25–35%","#2563EB",35],
    ["Pharmacology","15–22%","#7C3AED",22],
    ["Biochemistry & Nutrition","14–24%","#D97706",24],
    ["Gross Anatomy & Embryology","11–15%","#0891B2",15],
    ["Microbiology","10–15%","#059669",15],
    ["Histology & Cell Biology","8–13%","#6366F1",13],
    ["Behavioral Sciences","8–13%","#84CC16",13],
    ["Immunology","6–11%","#EC4899",11],
    ["Genetics","5–9%","#F59E0B",9],
  ];
  return (
    <Slide>
      <Tag color="#059669">Step 1 Basics</Tag>
      <H>What is <span style={{color:"#059669"}}>USMLE Step 1?</span></H>
      <Div color="#059669"/>
      {/* Format comparison old vs new */}
      <A delay={160}>
        <div style={{background:"#fff",borderRadius:13,padding:"10px 13px",border:"1px solid #E5EAF0",marginBottom:12,boxShadow:"0 2px 8px rgba(0,0,0,.05)"}}>
          <div style={{display:"grid",gridTemplateColumns:"1fr 80px 80px 100px",gap:4,marginBottom:6}}>
            {[["Feature","Before","New (2026)","Note"],].map(r=>(
              r.map((h,i)=><div key={i} style={{fontSize:10,fontWeight:800,color:"#9CA3AF",textTransform:"uppercase",letterSpacing:"1px",textAlign:i>0?"center":"left"}}>{h}</div>)
            ))}
          </div>
          {[
            ["Total Questions","280","280","No Change","#6B7280"],
            ["Total Blocks","7","14","Blocks Doubled","#E05252"],
            ["Questions/Block","40","20","Smaller Sections","#2563EB"],
            ["Time/Block","60 min","30 min","Shorter Blocks","#7C3AED"],
            ["Total Length","~8 Hours","~8 Hours","Same Exam Day","#059669"],
          ].map(([f,b,n,note,c],i)=>(
            <div key={i} style={{display:"grid",gridTemplateColumns:"1fr 80px 80px 100px",gap:4,
              padding:"6px 0",borderTop:"1px solid #F1F5F9",alignItems:"center"}}>
              <div style={{fontSize:13,color:"#374151",fontWeight:600}}>{f}</div>
              <div style={{fontSize:12,color:"#9CA3AF",textAlign:"center",textDecoration:"line-through"}}>{b}</div>
              <div style={{fontSize:13,color:c,fontWeight:800,textAlign:"center"}}>{n}</div>
              <div style={{fontSize:12,color:c,fontStyle:"italic",textAlign:"center"}}>{note}</div>
            </div>
          ))}
          <div style={{marginTop:8,background:"#FEF9EC",border:"1px solid #F59E0B30",borderRadius:8,padding:"7px 10px",display:"flex",gap:6}}>
            {["Same Exam Length","Twice the Blocks","30-Min Sections"].map((t,i)=>(
              <div key={i} style={{display:"flex",alignItems:"center",gap:4,flex:1}}>
                <span style={{fontSize:14,color:"#D97706"}}>✓</span>
                <span style={{fontSize:12,color:"#92400E",fontWeight:600}}>{t}</span>
              </div>
            ))}
          </div>
        </div>
      </A>
      <A delay={240}>
        <p style={{fontSize:13,color:"#374151",lineHeight:1.65,marginBottom:10}}>
          Pass/Fail format since Jan 2022. Minimum passing score: <strong>196</strong>. Conducted at Prometric centers worldwide. New format effective <strong>May 14, 2026.</strong>
        </p>
      </A>
      <A delay={300}><div style={{fontSize:10,fontWeight:700,letterSpacing:"2px",textTransform:"uppercase",color:"#9CA3AF",marginBottom:6}}>Subject Weightage (Disciplines)</div></A>
      <div style={{display:"flex",flexDirection:"column",gap:4,marginBottom:10}}>
        {disciplines.map(([d,p,col,n],i)=>(
          <A key={d} delay={340+i*40} dir="right">
            <div style={{display:"flex",alignItems:"center",gap:8}}>
              <div style={{fontSize:12,color:"#374151",width:120,flexShrink:0,lineHeight:1.3}}>{d}</div>
              <div style={{flex:1,height:6,background:"#F1F5F9",borderRadius:99,overflow:"hidden"}}>
                <div style={{height:"100%",background:col,borderRadius:99,
                  width:`${n}%`,transition:`width 0.8s ${0.2+i*.08}s cubic-bezier(0.23,1,0.32,1)`,
                  boxShadow:`0 0 6px ${col}60`}}/>
              </div>
              <div style={{fontSize:12,fontWeight:700,color:col,width:60,textAlign:"right",flexShrink:0,whiteSpace:"nowrap"}}>{p}</div>
            </div>
          </A>
        ))}
      </div>
      <A delay={760}>
        <div style={{fontSize:10,fontWeight:700,letterSpacing:"2px",textTransform:"uppercase",color:"#9CA3AF",marginBottom:6}}>System Weightage (Organ Systems)</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:4}}>
          {[["Blood & Lymphoreticular","8–13%","#E05252"],["Behavioral & Nervous","10–14%","#6366F1"],["MSK & Skin","7–12%","#D97706"],["Cardiovascular","6–11%","#EC4899"],["Respiratory & Renal","10–15%","#0891B2"],["GI","5–10%","#059669"],["Reproductive & Endocrine","9–13%","#7C3AED"],["Multisystem","11–16%","#F59E0B"],["Biostatistics & Epi","4–6%","#84CC16"]].map(([s,p,col])=>(
            <div key={s} style={{background:`${col}10`,border:`1px solid ${col}25`,borderRadius:6,padding:"3px 8px",display:"flex",gap:4,alignItems:"center"}}>
              <div style={{width:5,height:5,borderRadius:"50%",background:col,flexShrink:0}}/>
              <span style={{fontSize:10,color:"#374151",fontWeight:600}}>{s}</span>
              <span style={{fontSize:10,color:col,fontWeight:700}}>{p}</span>
            </div>
          ))}
        </div>
      </A>
    </Slide>
  );
}

function S04_WhenAndHowLong() {
  const p1 = [
    {sys:"Renal & Urinary",    days:"Day 1–7",    color:"#7C3AED"},
    {sys:"Cardiovascular",     days:"Day 8–21",   color:"#E05252"},
    {sys:"Respiratory",        days:"Day 22–30",  color:"#0891B2"},
    {sys:"GI System",          days:"Day 31–40",  color:"#059669"},
    {sys:"Endocrine",          days:"Day 41–47",  color:"#D97706"},
    {sys:"Reproductive",       days:"Day 48–55",  color:"#EC4899"},
    {sys:"MSK",                days:"Day 56–62",  color:"#F59E0B"},
    {sys:"Nervous System",     days:"Day 63–75",  color:"#6366F1"},
    {sys:"Hematology",         days:"Day 76–85",  color:"#F43F5E"},
    {sys:"Dermatology",        days:"Day 86–90",  color:"#14B8A6"},
  ];
  const p2 = [
    {sys:"Immunology",         days:"91–95",     color:"#06B6D4"},
    {sys:"Biochemistry",       days:"96–101",    color:"#8B5CF6"},
    {sys:"Gen Principles",     days:"102–105",   color:"#E05252"},
    {sys:"Biostatistics",      days:"106–110",   color:"#059669"},
    {sys:"Genetics",           days:"111–113",   color:"#A855F7"},
    {sys:"Psychiatry",         days:"114–120",   color:"#F59E0B"},
  ];
  return (
    <div style={{minHeight:"100vh",background:"#F7F8FC",display:"flex",flexDirection:"column",
      padding:"26px 26px 72px",position:"relative",overflow:"hidden"}}>

      <Tag color={GOLD}>Our Program Timeline</Tag>
      <H>120 days. Two phases.<br/><span style={{color:GOLD}}>One goal.</span></H>
      <A delay={160}>
        <div style={{display:"flex",gap:10,marginBottom:16,marginTop:10}}>
          {[["90d","Phase 1","#2563EB"],["30d","Phase 2",GOLD],["4,000+","QIDs","#059669"]].map(([v,l,col])=>(
            <div key={l} style={{flex:1,background:"#fff",borderRadius:12,padding:"12px 10px",
              textAlign:"center",border:`1px solid ${col}20`,boxShadow:"0 2px 8px rgba(0,0,0,.05)"}}>
              <div style={{fontFamily:"'Playfair Display',serif",fontSize:22,fontStyle:"italic",
                fontWeight:900,color:col,lineHeight:1}}>{v}</div>
              <div style={{fontSize:10,color:"#9CA3AF",textTransform:"uppercase",letterSpacing:"1.5px",marginTop:4,fontWeight:700}}>{l}</div>
            </div>
          ))}
        </div>
      </A>

      {/* Phase 1 */}
      <A delay={220}>
        <div style={{background:"#fff",borderRadius:16,border:"1.5px solid #BFDBFE",
          overflow:"hidden",marginBottom:12,boxShadow:"0 2px 12px rgba(37,99,235,.08)"}}>
          <div style={{background:"linear-gradient(135deg,#EFF6FF,#DBEAFE)",padding:"12px 16px",
            display:"flex",justifyContent:"space-between",alignItems:"flex-start",
            borderBottom:"1px solid #BFDBFE"}}>
            <div>
              <div style={{fontSize:16,fontWeight:800,color:"#1E40AF"}}>Phase 1 — Organ Systems</div>
              <div style={{fontSize:12,color:"#3B82F6",marginTop:2}}>90 Days · 10 systems · Live classes daily · UWorld tutor mode</div>
            </div>
            <div style={{fontFamily:"'Playfair Display',serif",fontSize:18,fontWeight:900,
              color:"#1E40AF",fontStyle:"italic"}}>90d</div>
          </div>
          <div style={{padding:"10px 14px"}}>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:5,marginBottom:8}}>
              {p1.map((s,i)=>(
                <div key={i} style={{display:"flex",alignItems:"center",gap:8,
                  padding:"6px 10px",borderRadius:8,background:"#F8FAFF",
                  border:"1px solid #E8EEFF"}}>
                  <div style={{width:7,height:7,borderRadius:"50%",background:s.color,flexShrink:0}}/>
                  <span style={{fontSize:13,fontWeight:600,color:"#1E293B",flex:1}}>{s.sys}</span>
                  <span style={{fontSize:10,color:"#94A3B8",fontFamily:"'DM Mono',monospace",
                    background:"#F1F5F9",borderRadius:4,padding:"1px 6px",flexShrink:0}}>{s.days}</span>
                </div>
              ))}
            </div>
            <div style={{background:"#F0FDF4",border:"1px solid #BBF7D0",borderRadius:8,
              padding:"7px 12px",display:"flex",alignItems:"center",gap:7}}>
              <div style={{width:7,height:7,borderRadius:"50%",background:"#16A34A",flexShrink:0}}/>
              <span style={{fontSize:13,fontWeight:700,color:"#15803D"}}>
                Microbiology parallel — 1 bug/day throughout Phase 1
              </span>
            </div>
          </div>
        </div>
      </A>

      {/* Divider */}
      <A delay={380}>
        <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:12}}>
          <div style={{flex:1,height:1.5,background:"linear-gradient(90deg,#BFDBFE,transparent)"}}/>
          <div style={{width:28,height:28,borderRadius:"50%",background:"#fff",
            border:`2px solid ${GOLD}`,display:"flex",alignItems:"center",justifyContent:"center",
            fontSize:13,color:GOLD,fontWeight:700}}>→</div>
          <div style={{flex:1,height:1.5,background:`linear-gradient(90deg,transparent,${GOLD}50)`}}/>
        </div>
      </A>

      {/* Phase 2 */}
      <A delay={440}>
        <div style={{background:"#fff",borderRadius:16,border:`1.5px solid ${GOLD}50`,
          overflow:"hidden",boxShadow:`0 2px 12px ${GOLD}18`}}>
          <div style={{background:"linear-gradient(135deg,#FFFBF0,#FFF3D0)",padding:"12px 16px",
            display:"flex",justifyContent:"space-between",alignItems:"flex-start",
            borderBottom:`1px solid ${GOLD}30`}}>
            <div>
              <div style={{fontSize:16,fontWeight:800,color:"#92400E"}}>Phase 2 — General Principles</div>
              <div style={{fontSize:12,color:"#B45309",marginTop:2}}>30 Days · NBMEs begin · Randomized timed UWorld</div>
            </div>
            <div style={{fontFamily:"'Playfair Display',serif",fontSize:18,fontWeight:900,
              color:"#92400E",fontStyle:"italic"}}>{GOLD?"30d":"30d"}</div>
          </div>
          <div style={{padding:"10px 14px"}}>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:5}}>
              {p2.map((s,i)=>(
                <div key={i} style={{display:"flex",alignItems:"center",gap:8,
                  padding:"6px 10px",borderRadius:8,background:"#FFFBF5",
                  border:`1px solid ${GOLD}20`}}>
                  <div style={{width:7,height:7,borderRadius:"50%",background:s.color,flexShrink:0}}/>
                  <span style={{fontSize:13,fontWeight:600,color:"#1E293B",flex:1}}>{s.sys}</span>
                  <span style={{fontSize:10,color:"#94A3B8",fontFamily:"'DM Mono',monospace",
                    background:"#FEF3C7",borderRadius:4,padding:"1px 6px",flexShrink:0}}>D{s.days}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </A>
    </div>
  );
}

function S05_StudyApproaches() {
  return (
    <Slide>
      <Tag color="#7C3AED">For Our Students</Tag>
      <H>Starting your<br/><span style={{color:"#7C3AED"}}>Step 1 journey with us.</span></H>
      <Div color="#7C3AED"/>
      <A delay={160}>
        <div style={{background:`linear-gradient(135deg,${NAVY},#0D1530)`,borderRadius:12,padding:"13px 15px",marginBottom:12}}>
          <div style={{fontSize:13,fontWeight:800,color:GOLD,marginBottom:5}}>You are not alone — and you are not behind.</div>
          <p style={{fontSize:14,color:"rgba(255,255,255,.78)",lineHeight:1.75}}>
            Many of our students feel their basics are rusty or incomplete — <strong style={{color:"#fff"}}>that is completely normal and expected.</strong> Our program is built for exactly this. We start from the very beginning — Anatomy, Embryology, Physiology — and build all the way through Pathology and Pharmacology, covering the <strong style={{color:GOLD}}>complete First Aid and UWorld</strong>, system by system, every single day.
          </p>
        </div>
      </A>
      <div style={{display:"flex",flexDirection:"column",gap:9,flex:1}}>
        <Card color="#2563EB" delay={260}>
          <div style={{fontSize:14,fontWeight:800,color:"#0A0F1E",marginBottom:7}}>What our program provides</div>
          <Bullet dot="#2563EB">Daily live classes — Anatomy, Embryology, Physiology → Pathology → Pharmacology, <strong>from scratch for every system.</strong></Bullet>
          <Bullet dot="#2563EB">Complete First Aid coverage with UWorld QIDs mapped to every topic.</Bullet>
          <Bullet dot="#2563EB">You don't need to figure out what to study — the plan is built, the resources are provided, the classes are live.</Bullet>
          <Bullet dot="#2563EB">Expert mentors available daily. No question goes unanswered.</Bullet>
        </Card>
        <Card color="#E05252" delay={380}>
          <div style={{fontSize:14,fontWeight:800,color:"#0A0F1E",marginBottom:7}}>Common concerns — addressed</div>
          <Bullet dot="#E05252"><strong>"My basics are weak"</strong> — We teach everything from basics. You don't need prior knowledge to start.</Bullet>
          <Bullet dot="#E05252"><strong>"It's been years since I studied"</strong> — Our structured daily schedule rebuilds everything systematically.</Bullet>
          <Bullet dot="#E05252"><strong>"I don't know where to start"</strong> — You don't need to. Day 1 of the schedule is built and waiting for you.</Bullet>
          <Bullet dot="#E05252"><strong>"I keep forgetting things"</strong> — Repetition through UWorld + daily review locks concepts in.</Bullet>
        </Card>
        <Card color="#059669" delay={500}>
          <div style={{fontSize:14,fontWeight:800,color:"#0A0F1E",marginBottom:7}}>Time commitment</div>
          <Bullet dot="#059669">Start at <strong>4–6 hours/day</strong> in the first few weeks as you build your study rhythm.</Bullet>
          <Bullet dot="#059669">Ramp up to <strong>6–8 hours/day</strong> through Phase 1 as you build momentum.</Bullet>
          <Bullet dot="#059669">Dedicated period: <strong>8–10 hours/day</strong> — full focus, no distractions.</Bullet>
          <Bullet dot="#059669">Consistency matters more than cramming. Show up every day — even for 4 hours is better than zero.</Bullet>
        </Card>
      </div>
    </Slide>
  );
}

function S06_Registration() {
  return (
    <Slide>
      <Tag color="#E05252">Registration</Tag>
      <H>Registering<br/><span style={{color:"#E05252"}}>for the exam.</span></H>
      <Div color="#E05252"/>
      <A delay={200}>
        <div style={{background:"#fff",borderRadius:13,padding:"14px 16px",
          border:"1px solid rgba(220,38,38,.15)",borderTop:"3px solid #E05252",
          boxShadow:"0 2px 10px rgba(0,0,0,.05)",marginBottom:14}}>
          <Bullet>Register for your exam <strong>as soon as you can.</strong></Bullet>
          <Bullet>Registration can take between <strong>6 to 8 weeks</strong> on average.</Bullet>
          <Bullet>It is a relatively straightforward process.</Bullet>
          <Bullet>Begin your registration process at least <strong>6–8 months before</strong> your intended exam date.</Bullet>
          <Bullet>Seats for the exam typically begin opening up 6 months prior.</Bullet>
        </div>
      </A>
      <A delay={340}>
        <div style={{fontSize:12,fontWeight:700,letterSpacing:"2px",textTransform:"uppercase",color:"#9CA3AF",marginBottom:10}}>IMG Expenses Overview</div>
      </A>
      <A delay={380}>
        <div style={{background:"#fff",borderRadius:13,padding:"2px 0",border:"1px solid #E5EAF0",
          overflow:"hidden",boxShadow:"0 2px 8px rgba(0,0,0,.04)"}}>
          {[["MyIntealth Account Creation","$100"],["Application for ECFMG Certification","$560"],["Credential Verification","$200"],["USMLE Step 1 Registration","$695"],["USMLE Step 2 CK Registration","$695"],["Pathways","$925"],["OET","~$400"],["ERAS & miscellaneous","$3,500+"]].map(([item,cost],i)=>(
            <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",
              padding:"8px 14px",borderBottom:i<7?"1px solid #F1F5F9":"none",
              background:i%2===0?"#FAFAF8":"#fff"}}>
              <span style={{fontSize:13,color:"#374151"}}>{item}</span>
              <span style={{fontSize:13,fontWeight:700,color:"#E05252",fontFamily:"'Playfair Display',serif"}}>{cost}</span>
            </div>
          ))}
        </div>
      </A>
      <A delay={600}>
        <div style={{background:"#FEF9EC",border:"1px solid #F59E0B30",borderRadius:10,padding:"9px 13px",marginTop:8}}>
          <p style={{fontSize:13,color:"#92400E",lineHeight:1.65}}>
            <strong>Expected fee change: August 19, 2025.</strong> MyIntealth now required for ECFMG certification. Registration costs have been restructured — plan finances accordingly and start the ECFMG process as early as possible.
          </p>
        </div>
      </A>
    </Slide>
  );
}

function S07_Resources() {
  return (
    <Slide>
      <Tag color="#059669">Resources</Tag>
      <H>What to use<br/><span style={{color:"#059669"}}>and what to avoid.</span></H>
      <Div color="#059669"/>
      <A delay={160}>
        <div style={{background:`linear-gradient(135deg,${NAVY},#0D1530)`,borderRadius:13,padding:"12px 15px",marginBottom:12}}>
          <div style={{fontSize:13,fontWeight:800,color:GOLD,marginBottom:4}}>The golden rule</div>
          <div style={{fontSize:14,color:"rgba(255,255,255,.8)",lineHeight:1.6}}>There is no shortage of great resources. The biggest favor you can do yourself: <strong style={{color:GOLD}}>Keep your resources limited!</strong></div>
          <div style={{fontSize:13,color:"rgba(255,255,255,.5)",marginTop:6}}>No matter what combo you go for, 2 components must always be present: <strong style={{color:"#fff"}}>First Aid</strong> and <strong style={{color:"#fff"}}>UWorld / Amboss / both.</strong></div>
        </div>
      </A>
      <A delay={280}><div style={{fontSize:10,fontWeight:700,letterSpacing:"2px",textTransform:"uppercase",color:"#9CA3AF",marginBottom:8}}>Video Resources</div></A>
      <div style={{display:"flex",flexDirection:"column",gap:5,marginBottom:14}}>
        {[
          ["Boards and Beyond (BnB)","Jack-of-all-trades. Videos on every subject and system.","#2563EB"],
          ["Sketchy","Picture mnemonics. Well-known for microbiology and pharmacology.","#7C3AED"],
          ["Pathoma","The OG for pathology. Dr. Sattar always comes in clutch.","#E05252"],
          ["Physeo","Relatively newer. Videos on every subject and system. Compared to BnB a lot.","#0891B2"],
          ["Pixorize","Relatively newer. Picture mnemonics. Known for biochemistry. Compared to Sketchy a lot.","#D97706"],
          ["Bootcamp","Relatively newer. Videos on every subject and system. Compared to BnB a lot.","#059669"],
          ["Kaplan","Oldest. Videos on every subject and system. Barely used anymore.","#9CA3AF"],
        ].map(([n,d,c],i)=>(
          <A key={n} delay={320+i*50} dir="right">
            <div style={{display:"flex",gap:9,alignItems:"flex-start",background:"#fff",
              borderRadius:9,padding:"8px 11px",border:"1px solid #E5EAF0",borderLeft:`3px solid ${c}`}}>
              <div style={{fontSize:13,fontWeight:800,color:"#0A0F1E",width:88,flexShrink:0}}>{n}</div>
              <div style={{fontSize:13,color:"#6B7280",lineHeight:1.5}}>{d}</div>
            </div>
          </A>
        ))}
      </div>
      <A delay={680}>
        <div style={{background:`${GOLD}0D`,border:`1px solid ${GOLD}28`,borderRadius:10,padding:"10px 13px"}}>
          <div style={{fontSize:10,fontWeight:700,color:GOLD,letterSpacing:"1.5px",textTransform:"uppercase",marginBottom:5}}>Popular Combos</div>
          <div style={{fontSize:13,color:"#374151",lineHeight:1.6}}>
            1. <strong>Pathoma</strong> + Sketchy (micro/pharma) + <strong>BnB</strong> (everything else) — Most popular<br/>
            2. <strong>Pixorize</strong> (biochem) + Sketchy (micro/pharma) + <strong>Physeo</strong> (everything else)<br/>
            3. <strong>Pathoma</strong> (pathology) + <strong>Bootcamp</strong> (everything else)
          </div>
        </div>
      </A>
    </Slide>
  );
}

function S08_YouTube_Anki() {
  return (
    <Slide>
      <Tag color="#E05252">Resources cont'd</Tag>
      <H>YouTube, Anki<br/><span style={{color:"#E05252"}}>& additional tools.</span></H>
      <Div color="#E05252"/>
      <A delay={160}><div style={{fontSize:10,fontWeight:700,letterSpacing:"2px",textTransform:"uppercase",color:"#9CA3AF",marginBottom:8}}>YouTube Channels</div></A>
      <div style={{display:"flex",flexDirection:"column",gap:5,marginBottom:16}}>
        {[
          ["Dirty Medicine","Very popular high-yield videos for the dedicated period. Highly recommended for dedicated period.","#E05252"],
          ["Randy Neil","Very popular for biostatistics. The go-to resource for stats.","#2563EB"],
        ].map(([n,d,c],i)=>(
          <A key={n} delay={200+i*60}>
            <div style={{display:"flex",gap:9,background:"#fff",borderRadius:9,padding:"8px 12px",
              border:"1px solid #E5EAF0",borderLeft:`3px solid ${c}`}}>
              <span style={{fontSize:13,fontWeight:800,color:"#0A0F1E",width:110,flexShrink:0}}>{n}</span>
              <span style={{fontSize:13,color:"#6B7280",lineHeight:1.5}}>{d}</span>
            </div>
          </A>
        ))}
      </div>

      <A delay={460}><div style={{fontSize:10,fontWeight:700,letterSpacing:"2px",textTransform:"uppercase",color:"#9CA3AF",marginBottom:8}}>Anki — Spaced Repetition</div></A>
      <Card color={GOLD} delay={500} style={{marginBottom:12}}>
        <Bullet dot={GOLD}>Use pre-made decks (e.g. <strong>AnKing</strong>) only for subjects requiring rote learning — microbiology and pharmacology.</Bullet>
        <Bullet dot={GOLD}>There are many pros and cons. Most cons stem from people not using it correctly.</Bullet>
        <Bullet dot={GOLD}>Over 4 years of Anki experience + 30,000 matured cards went into the recommended Anki guide — follow it thoroughly.</Bullet>
      </Card>

      <A delay={620}><div style={{fontSize:10,fontWeight:700,letterSpacing:"2px",textTransform:"uppercase",color:"#9CA3AF",marginBottom:8}}>Additional Resources</div></A>
      <div style={{display:"flex",flexDirection:"column",gap:5}}>
        {[
          ["Mehlmanmedical Notes","Free high-yield notes from all systems tested in Step 1. Good for dedicated period revision if you prefer reading.","#0891B2"],
        ].map(([n,d,c],i)=>(
          <A key={n} delay={660+i*70}>
            <div style={{display:"flex",gap:9,background:"#fff",borderRadius:9,padding:"8px 12px",
              border:"1px solid #E5EAF0",borderLeft:`3px solid ${c}`}}>
              <span style={{fontSize:13,fontWeight:800,color:"#0A0F1E",width:128,flexShrink:0}}>{n}</span>
              <span style={{fontSize:13,color:"#6B7280",lineHeight:1.5}}>{d}</span>
            </div>
          </A>
        ))}
      </div>
    </Slide>
  );
}

function S09_UWorldModes() {
  return (
    <Slide>
      <Tag color="#2563EB">UWorld Strategy</Tag>
      <H>How we use<br/><span style={{color:"#2563EB"}}>UWorld in our program.</span></H>
      <Div color="#2563EB"/>
      <A delay={160}>
        <div style={{background:`linear-gradient(135deg,${NAVY},#0D1530)`,borderRadius:12,padding:"11px 15px",marginBottom:14}}>
          <div style={{fontSize:13,fontWeight:800,color:GOLD,marginBottom:4}}>The gold standard</div>
          <p style={{fontSize:14,color:"rgba(255,255,255,.75)",lineHeight:1.7}}>
            We have collected <strong style={{color:"#fff"}}>all UWorld QIDs</strong> and mapped them against every single topic in First Aid. This means for each topic you study, the exact UWorld questions for that topic are already queued and ready — <strong style={{color:GOLD}}>zero searching, zero wasting time.</strong>
          </p>
        </div>
      </A>
      <div style={{display:"flex",flexDirection:"column",gap:10,flex:1}}>
        <Card color="#7C3AED" delay={260}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
            <div style={{background:"#7C3AED",color:"#fff",borderRadius:6,padding:"2px 10px",fontSize:10,fontWeight:800,letterSpacing:"1px"}}>PASS 1 · Pre-Dedicated</div>
          </div>
          <div style={{fontSize:15,fontWeight:800,color:"#0A0F1E",marginBottom:6}}>Tutor Mode — System-wise</div>
          <div style={{fontSize:12,fontStyle:"italic",color:"#7C3AED",marginBottom:8}}>"WHY is every wrong option wrong?"</div>
          <Bullet dot="#7C3AED">Done <strong>system by system</strong> following the study plan. Today's system = today's mapped UWorld QIDs.</Bullet>
          <Bullet dot="#7C3AED">Tutor mode: see explanation after every question. Reason through every option.</Bullet>
          <Bullet dot="#7C3AED">Review questions <strong>with each system daily</strong> — not all at the end.</Bullet>
          <Bullet dot="#7C3AED">Goal: build deep understanding, not speed. Cover every concept properly the first time.</Bullet>
        </Card>
        <Card color="#2563EB" delay={400}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
            <div style={{background:"#2563EB",color:"#fff",borderRadius:6,padding:"2px 10px",fontSize:10,fontWeight:800,letterSpacing:"1px"}}>PASS 2 · Dedicated Period</div>
          </div>
          <div style={{fontSize:15,fontWeight:800,color:"#0A0F1E",marginBottom:6}}>Timed Mode — Randomized</div>
          <div style={{fontSize:12,fontStyle:"italic",color:"#2563EB",marginBottom:8}}>"Get to the answer in under a minute."</div>
          <Bullet dot="#2563EB">Fully <strong>randomized blocks</strong> across all systems — simulating real exam conditions.</Bullet>
          <Bullet dot="#2563EB">Timed mode: timer runs backward. No explanations until block is done.</Bullet>
          <Bullet dot="#2563EB">After each block: review <strong>incorrects and marked questions only</strong> — read explanations thoroughly.</Bullet>
          <Bullet dot="#2563EB">Goal: build exam-ready speed and reflexes. Identify remaining weak areas.</Bullet>
        </Card>
      </div>
    </Slide>
  );
}

function S10_UWorldSystem() {
  return (
    <Slide>
      <Tag color="#2563EB">UWorld Strategy</Tag>
      <H>System-wise first,<br/><span style={{color:"#2563EB"}}>then randomized.</span></H>
      <Div color="#2563EB"/>
      <div style={{display:"flex",flexDirection:"column",gap:10,marginBottom:14}}>
        <Card color="#7C3AED" delay={160}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:6}}>
            <div style={{background:"#EDE9FE",borderRadius:6,padding:"2px 9px",fontSize:10,fontWeight:800,color:"#7C3AED",letterSpacing:"1px"}}>PASS 1 · Pre-Dedicated</div>
            <div style={{fontSize:15,fontWeight:800,color:"#0A0F1E"}}>System-wise (Tutor Mode)</div>
          </div>
          <p style={{fontSize:14,color:"#374151",lineHeight:1.65}}>In our program, the first pass is done <strong>system by system</strong> — matching your daily study plan. When you study Cardiovascular today, you do Cardiovascular UWorld QIDs today. This is how concepts lock in — context + questions together.</p>
        </Card>
        <Card color="#2563EB" delay={280}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:6}}>
            <div style={{background:"#DBEAFE",borderRadius:6,padding:"2px 9px",fontSize:10,fontWeight:800,color:"#2563EB",letterSpacing:"1px"}}>PASS 2 · Dedicated</div>
            <div style={{fontSize:15,fontWeight:800,color:"#0A0F1E"}}>Randomized (Timed Mode)</div>
          </div>
          <p style={{fontSize:14,color:"#374151",lineHeight:1.65}}>Once all systems are covered, you switch to <strong>fully randomized blocks</strong>. This mirrors the real exam format and trains your brain to switch contexts rapidly — exactly what Step 1 requires.</p>
        </Card>
      </div>
      <A delay={420}><div style={{fontSize:10,fontWeight:700,letterSpacing:"2px",textTransform:"uppercase",color:"#9CA3AF",marginBottom:10}}>Revision strategy — how to stay on top of everything</div></A>
      <div style={{display:"flex",flexDirection:"column",gap:6}}>
        {[
          ["Daily","Review UWorld questions with the system you are currently studying. Do incorrects + marked same day."],
          ["Weekly","Every Sunday: rapid revision of the week's systems. Flag any topic that keeps coming up wrong."],
          ["Post-system","When you finish a system, do a rapid targeted UWorld block on that system before moving on."],
          ["Dedicated period","Randomized timed blocks daily. Review only incorrects and marked. Build your weak topic list."],
        ].map(([label,desc],i)=>(
          <A key={i} delay={460+i*70} dir="right">
            <div style={{display:"flex",alignItems:"flex-start",gap:9,background:"#fff",
              borderRadius:9,padding:"9px 12px",border:"1px solid #E5EAF0"}}>
              <div style={{background:"#2563EB",color:"#fff",borderRadius:5,padding:"2px 8px",
                fontSize:10,fontWeight:800,flexShrink:0,whiteSpace:"nowrap"}}>{label}</div>
              <span style={{fontSize:13,color:"#374151",lineHeight:1.6}}>{desc}</span>
            </div>
          </A>
        ))}
      </div>
    </Slide>
  );
}

function S11_QuestionSolving() {
  return (
    <Slide>
      <Tag color="#E05252">Question Strategy</Tag>
      <H>Question-solving<br/><span style={{color:"#E05252"}}>strategy basics.</span></H>
      <Div color="#E05252"/>
      <div style={{display:"flex",flexDirection:"column",gap:8,flex:1}}>
        <Card color="#2563EB" delay={160}>
          <div style={{fontSize:14,fontWeight:800,color:"#0A0F1E",marginBottom:7}}>The recommended approach</div>
          <div style={{display:"flex",flexDirection:"column",gap:4}}>
            {[
              ["1","Read the lead-in first","The last line — the actual question being asked."],
              ["2","Glance the answer choices","Get a sense of what the question will test you on."],
              ["3","Read the full question","Highlight whatever feels important."],
              ["4","Read each answer choice carefully","Then choose the one that makes the most sense."],
            ].map(([n,t,d])=>(
              <div key={n} style={{display:"flex",gap:9,alignItems:"flex-start"}}>
                <div style={{width:16,height:16,borderRadius:"50%",background:"#2563EB",flexShrink:0,
                  display:"flex",alignItems:"center",justifyContent:"center",fontSize:7,fontWeight:800,color:"#fff",marginTop:1}}>{n}</div>
                <div>
                  <span style={{fontSize:13,fontWeight:700,color:"#0A0F1E"}}>{t} — </span>
                  <span style={{fontSize:13,color:"#6B7280"}}>{d}</span>
                </div>
              </div>
            ))}
          </div>
        </Card>
        <Card color="#F59E0B" delay={300}>
          <div style={{fontSize:14,fontWeight:800,color:"#0A0F1E",marginBottom:6}}>On changing your answer</div>
          <p style={{fontSize:14,color:"#374151",lineHeight:1.65}}>After marking an answer you'll feel compelled to change it. <strong>Avoid this unless you have two (2) very strong reasons</strong> to prefer the other choice. Your gut feeling is usually right — learn to trust it more, especially after reading the question carefully.</p>
        </Card>
        <Card color="#7C3AED" delay={420}>
          <div style={{fontSize:14,fontWeight:800,color:"#0A0F1E",marginBottom:6}}>On timed mode — the 1-minute rule</div>
          <p style={{fontSize:14,color:"#374151",lineHeight:1.65}}>Answer in under a minute. If stuck — <strong>mark your best answer, flag the question, and move on.</strong> Come back to flagged questions at the end with a fresh mind. The subconscious worry about remaining questions disappears once you've gone through the full block — you'll see the flagged question in a completely new light.</p>
        </Card>
      </div>
    </Slide>
  );
}

function S12_ReviewingQuestions() {
  return (
    <Slide>
      <Tag color="#059669">Reviewing</Tag>
      <H>How to review<br/><span style={{color:"#059669"}}>your question blocks.</span></H>
      <Div color="#059669"/>
      <A delay={160}>
        <div style={{display:"flex",gap:8,marginBottom:14}}>
          {[["1st","Incorrects","#E05252","Your biggest learning opportunity"],
            ["2nd","Marked","#F59E0B","Questions you were unsure about"],
            ["3rd","Corrects","#059669","Reinforce what you know"]].map(([n,l,c,d])=>(
            <div key={n} style={{flex:1,background:"#fff",borderRadius:11,padding:"10px 10px",
              border:`1px solid ${c}20`,borderTop:`3px solid ${c}`,textAlign:"center",
              boxShadow:"0 2px 8px rgba(0,0,0,.05)"}}>
              <div style={{fontSize:10,color:c,fontWeight:800,letterSpacing:"1px",textTransform:"uppercase"}}>{n}</div>
              <div style={{fontSize:15,fontWeight:800,color:"#0A0F1E",margin:"3px 0"}}>{l}</div>
              <div style={{fontSize:12,color:"#9CA3AF",lineHeight:1.4}}>{d}</div>
            </div>
          ))}
        </div>
      </A>
      <div style={{display:"flex",flexDirection:"column",gap:7,marginBottom:12}}>
        {[
          ["Focus on the explanation","95% of the time it is more than enough to clear your confusion. When it's not, cover it from your preferred resource. BnB and FA are great for anything.","#2563EB"],
          ["Cover it so you never get it wrong again","If you get a question wrong, set the standard that you'll never get that wrong again. This makes you actively think and pay attention while reviewing.","#7C3AED"],
          ["Don't just read — understand","A lot of people review by reading explanations but absorbing nothing. Always try to understand what is going on in every question.","#059669"],
          ["Maintain a list of weak subtopics","Make a list of every subtopic you get wrong. Keep it throughout your prep — it becomes extremely useful during the dedicated period.","#E05252"],
          ["UWorld is a LEARNING tool","Expecting high scores from the beginning is unrealistic and unhealthy. Do not let your scores get you down. Mindset matters most.","#F59E0B"],
        ].map(([t,d,c],i)=>(
          <A key={i} delay={200+i*70} dir="right">
            <div style={{display:"flex",gap:9,background:"#fff",borderRadius:10,padding:"9px 12px",
              border:`1px solid ${c}15`,borderLeft:`3px solid ${c}`,boxShadow:"0 1px 5px rgba(0,0,0,.04)"}}>
              <div>
                <div style={{fontSize:14,fontWeight:700,color:"#0A0F1E",marginBottom:2}}>{t}</div>
                <div style={{fontSize:13,color:"#6B7280",lineHeight:1.55}}>{d}</div>
              </div>
            </div>
          </A>
        ))}
      </div>
    </Slide>
  );
}

function S13_WhyWrong() {
  return (
    <Slide>
      <Tag color="#F59E0B">Reviewing</Tag>
      <H>3 reasons you get<br/><span style={{color:"#F59E0B"}}>a question wrong.</span></H>
      <Div color="#F59E0B"/>
      <A delay={160}>
        <p style={{fontSize:14,color:"#374151",lineHeight:1.7,marginBottom:14}}>
          If you make Anki flashcards while reviewing, recognizing <em>why</em> you got a question wrong is crucial. Once you know the reason, your card needs to tackle that specific problem.
        </p>
      </A>
      <div style={{display:"flex",flexDirection:"column",gap:12,flex:1}}>
        {[
          ["01","Never knew it","#E05252","You did not know the fact or concept the question was testing. You had never studied it or read it anywhere.","Make a card that teaches you the concept from scratch."],
          ["02","Knew it, forgot it","#F59E0B","You knew the fact or concept the question was testing, but you forgot when it mattered most.","Make a card that focuses on recall of that specific fact under pressure."],
          ["03","Stuck between 2 options","#7C3AED","You got stuck between 2 answer choices. You were unable to differentiate what would make one the answer and the other not.","Make a card that explains the distinguishing feature between the two options."],
        ].map(([n,t,c,d,tip])=>(
          <Card key={n} color={c} delay={parseInt(n)*80+100} style={{flex:1}}>
            <div style={{display:"flex",gap:12,alignItems:"flex-start"}}>
              <div style={{fontFamily:"'Playfair Display',serif",fontSize:18,fontWeight:900,
                color:c,opacity:.4,flexShrink:0,lineHeight:1}}>{n}</div>
              <div>
                <div style={{fontSize:15,fontWeight:800,color:"#0A0F1E",marginBottom:4}}>{t}</div>
                <div style={{fontSize:14,color:"#374151",lineHeight:1.6,marginBottom:6}}>{d}</div>
                <div style={{fontSize:13,color:c,lineHeight:1.5,fontStyle:"italic"}}>💡 Anki fix: {tip}</div>
              </div>
            </div>
          </Card>
        ))}
      </div>
      <InfoBox color="#F59E0B" delay={600}>
        By putting your incorrects into one of these three boxes, you will be able to make much more specific and better flashcards.
      </InfoBox>
    </Slide>
  );
}

function S14_SelfAssessments() {
  return (
    <Slide>
      <Tag color="#7C3AED">Self-Assessments</Tag>
      <H>Know where<br/><span style={{color:"#7C3AED"}}>you stand.</span></H>
      <Div color="#7C3AED"/>
      <A delay={160}>
        <p style={{fontSize:14,color:"#374151",lineHeight:1.7,marginBottom:12}}>
          Self-assessments help you gauge your level of preparation. These are typically utilized in your final months of dedicated study.
        </p>
      </A>
      <div style={{display:"flex",gap:9,marginBottom:12}}>
        {[
          {n:"NBMEs",nt:"7 tests (25–31)",cost:"$70 each",c:"#2563EB",pts:["Offered by same body that writes Step exams","200 Qs / 4 blocks","50 Qs per block","Best preparation predictor"]},
          {n:"UWSAs",nt:"3 tests",cost:"$50 each / $120 bundle",c:"#7C3AED",pts:["UWSA1, UWSA2, UWSA3","160 Qs / 4 blocks","40 Qs per block","UWSA1+2 in 6-month UWorld package","UWSA3 in 12-month package"]},
          {n:"Free 120",nt:"1 test",cost:"Free",c:"#059669",pts:["Same interface as real exam","120 Qs / 3 blocks","40 Qs per block","Updated every few months","orientation.nbme.org"]},
        ].map((t,i)=>(
          <Card key={i} color={t.c} delay={200+i*100} style={{flex:1}}>
            <div style={{fontSize:15,fontWeight:800,color:"#0A0F1E",marginBottom:2}}>{t.n}</div>
            <div style={{fontSize:12,color:t.c,fontWeight:700,marginBottom:7}}>{t.nt} · {t.cost}</div>
            {t.pts.map((p,j)=><Bullet key={j} dot={t.c} size={9}>{p}</Bullet>)}
          </Card>
        ))}
      </div>
      <A delay={500}><div style={{fontSize:10,fontWeight:700,letterSpacing:"2px",textTransform:"uppercase",color:"#9CA3AF",marginBottom:8}}>Recommended Assessment Timeline</div></A>
      <div style={{display:"flex",flexDirection:"column",gap:0,position:"relative"}}>
        <div style={{position:"absolute",left:12,top:12,bottom:12,width:2,
          background:"linear-gradient(180deg,#2563EB,#7C3AED,#7C3AED,#E05252,#059669)",opacity:.3}}/>
        {[["UWSA1","At least 46 days before exam — allows free rescheduling if needed","#2563EB"],
          ["Any NBMEs","1 per week between UWSAs and before UWSA1","#6B7280"],
          ["UWSA3","3 weeks before your exam","#7C3AED"],
          ["UWSA2","1 week before your exam","#E05252"],
          ["Free 120","Same day as UWSA2, or right after","#059669"]].map(([l,w,c],i)=>(
          <A key={i} delay={540+i*80} dir="right">
            <div style={{display:"flex",alignItems:"center",gap:10,padding:"8px 0 8px 32px",
              borderBottom:i<4?"1px solid #F1F5F9":"none"}}>
              <div style={{position:"absolute",left:6,width:14,height:14,borderRadius:"50%",
                background:"#fff",border:`2px solid ${c}`,
                display:"flex",alignItems:"center",justifyContent:"center",
                fontSize:7,fontWeight:800,color:c}}>{i+1}</div>
              <div style={{fontWeight:800,fontSize:14,color:"#0A0F1E",width:64,flexShrink:0}}>{l}</div>
              <div style={{fontSize:13,color:"#9CA3AF",flex:1,lineHeight:1.5}}>{w}</div>
            </div>
          </A>
        ))}
      </div>
    </Slide>
  );
}

function S15_EightHourSim() {
  return (
    <Slide>
      <Tag color="#E05252">Final Prep</Tag>
      <H>8-Hour exam<br/><span style={{color:"#E05252"}}>simulation.</span></H>
      <Div color="#E05252"/>
      <A delay={160}>
        <div style={{background:`linear-gradient(135deg,${NAVY},#0D1530)`,borderRadius:14,padding:"16px 18px",marginBottom:14}}>
          <div style={{fontSize:14,fontWeight:800,color:GOLD,marginBottom:8}}>The 8-Hour Simulation</div>
          <p style={{fontSize:14,color:"rgba(255,255,255,.7)",lineHeight:1.7,marginBottom:8}}>
            In the last month of your exam, simulate the entire 8-hour length of Step 1 at least once — with breaks exactly as you plan to take them on the real day. <strong style={{color:"#fff"}}>Start at 9 AM. Finish by 5 PM.</strong>
          </p>
          <div style={{fontSize:12,color:"rgba(255,255,255,.4)",fontStyle:"italic"}}>
            This is the most important dress rehearsal you can do for your mind and body.
          </div>
        </div>
      </A>
      <A delay={300}><div style={{fontSize:10,fontWeight:700,letterSpacing:"2px",textTransform:"uppercase",color:"#9CA3AF",marginBottom:8}}>Ways to achieve the 280-question target</div></A>
      <div style={{display:"flex",flexDirection:"column",gap:7,marginBottom:14}}>
        {[
          ["Option A (most common)","UWSA2 (160 Qs) + Free 120 (120 Qs) on the same day = 280 questions total","#E05252"],
          ["Option B","Any NBME + 2 blocks of UWorld/Amboss/any other QB","#2563EB"],
          ["Option C","UWSA2 + 3 blocks of UWorld/Amboss/any other QB","#7C3AED"],
          ["Option D","Free 120 + 4 blocks of UWorld/Amboss/any other QB","#059669"],
        ].map(([o,d,c],i)=>(
          <A key={i} delay={340+i*80} dir="right">
            <div style={{display:"flex",gap:9,background:"#fff",borderRadius:10,padding:"9px 12px",
              border:`1px solid ${c}15`,borderLeft:`3px solid ${c}`}}>
              <div style={{fontSize:12,fontWeight:800,color:c,width:70,flexShrink:0}}>{o}</div>
              <div style={{fontSize:13,color:"#374151",lineHeight:1.55}}>{d}</div>
            </div>
          </A>
        ))}
      </div>
      <A delay={680}>
        <div style={{background:"#fff",borderRadius:13,padding:"13px 15px",
          border:"1px solid #E5EAF0",boxShadow:"0 2px 8px rgba(0,0,0,.05)"}}>
          <div style={{fontSize:13,fontWeight:800,color:"#0A0F1E",marginBottom:6}}>How many assessments total?</div>
          <Bullet>Give at least <strong>2–3 NBMEs</strong>, all <strong>3 UWSAs</strong>, and <strong>Free120</strong> over the course of prep.</Bullet>
          <Bullet>Majority of these should be during your dedicated period.</Bullet>
          <Bullet>Some prefer to give an NBME at the very beginning of prep to see where they stand and how much work lies ahead.</Bullet>
        </div>
      </A>
    </Slide>
  );
}

function S17_DedicatedPeriod() {
  return (
    <Slide>
      <Tag color="#E05252">Dedicated Period</Tag>
      <H>The dedicated period<br/><span style={{color:"#E05252"}}>dos & don'ts.</span></H>
      <Div color="#E05252"/>
      <A delay={160}>
        <div style={{background:"#fff",borderRadius:13,padding:"13px 15px",
          border:"1px solid rgba(220,38,38,.15)",borderTop:"3px solid #E05252",
          boxShadow:"0 2px 10px rgba(0,0,0,.05)",marginBottom:14}}>
          <div style={{fontSize:14,fontWeight:800,color:"#0A0F1E",marginBottom:7}}>What the dedicated period is</div>
          <Bullet>This is when you do <strong>nothing but study for Step 1.</strong></Bullet>
          <Bullet>Typically <strong>1 to 2 months</strong> long.</Bullet>
          <Bullet>Your goal: attempt <strong>multiple practice tests</strong> + solve a <strong>large number of UWorld questions.</strong></Bullet>
          <Bullet>In the last few weeks: do rapid UWorld blocks — review <strong>only wrongs + marked</strong>. Skip correctly answered questions whose concepts you already know.</Bullet>
        </div>
      </A>
      <A delay={300}><div style={{fontSize:10,fontWeight:700,letterSpacing:"2px",textTransform:"uppercase",color:"#9CA3AF",marginBottom:8}}>Dos and Don'ts</div></A>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:7}}>
        {[
          ["✓ Do","Take time to rest and spend time with loved ones","#059669"],
          ["✓ Do","Eat healthy and refrain from unhygienic food","#059669"],
          ["✓ Do","Maintain a good sleep schedule from now","#059669"],
          ["✓ Do","Trust your preparation going into the exam","#059669"],
          ["✗ Don't","Push yourself to breaking point — many burn out","#E05252"],
          ["✗ Don't","Skip breaks — rest is part of the process","#E05252"],
          ["✗ Don't","Panic over scores — they don't define readiness","#E05252"],
          ["✗ Don't","Study right up to the night before the exam","#E05252"],
        ].map(([tag,text,c],i)=>(
          <A key={i} delay={340+i*50}>
            <div style={{display:"flex",gap:7,alignItems:"flex-start",background:"#fff",
              borderRadius:9,padding:"8px 10px",border:`1px solid ${c}15`,borderLeft:`2.5px solid ${c}`}}>
              <span style={{fontSize:10,fontWeight:800,color:c,flexShrink:0}}>{tag}</span>
              <span style={{fontSize:13,color:"#374151",lineHeight:1.5}}>{text}</span>
            </div>
          </A>
        ))}
      </div>
    </Slide>
  );
}

function S18_TwoDaysBefore() {
  return (
    <Slide>
      <Tag color={GOLD}>Exam Prep</Tag>
      <H>2 days before<br/><span style={{color:GOLD}}>your exam.</span></H>
      <Div/>
      <div style={{display:"flex",flexDirection:"column",gap:10,flex:1}}>
        <Card color={GOLD} delay={160}>
          <div style={{fontSize:14,fontWeight:800,color:"#0A0F1E",marginBottom:6}}>👕 Your Outfit</div>
          <Bullet dot={GOLD}>Have <strong>no/few pockets</strong> — they get regularly checked at entry.</Bullet>
          <Bullet dot={GOLD}>Must be <strong>comfortable</strong> to wear (8 hours is a long time).</Bullet>
          <Bullet dot={GOLD}>Include a <strong>jacket or front-zipped hoodie</strong> — exam centers get quite cold.</Bullet>
        </Card>
        <Card color="#059669" delay={260}>
          <div style={{fontSize:14,fontWeight:800,color:"#0A0F1E",marginBottom:6}}>🍌 Food to Pack</div>
          <Bullet dot="#059669">Protein bars, cold coffee, bananas, dates — good energy, no crash.</Bullet>
          <Bullet dot="#059669"><strong>Avoid oily or greasy food.</strong> Avoid sugar — causes a crash mid-exam.</Bullet>
          <Bullet dot="#059669">You cannot buy food from within the exam center.</Bullet>
        </Card>
        <Card color="#2563EB" delay={360}>
          <div style={{fontSize:14,fontWeight:800,color:"#0A0F1E",marginBottom:6}}>📋 Documents & Bag</div>
          <Bullet dot="#2563EB">Exam permit — <strong>printed</strong>. Have a spare copy advisable.</Bullet>
          <Bullet dot="#2563EB">Your <strong>CNIC and/or passport.</strong></Bullet>
          <Bullet dot="#2563EB">Ready your bag the night before — don't rush on the day.</Bullet>
        </Card>
        <Card color="#7C3AED" delay={460}>
          <div style={{fontSize:14,fontWeight:800,color:"#0A0F1E",marginBottom:6}}>🚗 Transport & Logistics</div>
          <Bullet dot="#7C3AED">Know exactly where your exam center is and how to get there.</Bullet>
          <Bullet dot="#7C3AED">Ensure your mode of transport is as <strong>comfortable as possible.</strong></Bullet>
          <Bullet dot="#7C3AED">Do not tire yourself before the exam even begins.</Bullet>
        </Card>
      </div>
    </Slide>
  );
}

function S19_DayBeforeAndExamDay() {
  return (
    <Slide>
      <Tag color="#E05252">Exam Prep</Tag>
      <H>1 day before &<br/><span style={{color:"#E05252"}}>exam day.</span></H>
      <Div color="#E05252"/>
      <div style={{display:"flex",flexDirection:"column",gap:10,flex:1}}>
        <Card color="#059669" delay={160}>
          <div style={{fontSize:14,fontWeight:800,color:"#0A0F1E",marginBottom:6}}>1 Day Before — The rest day</div>
          <Bullet dot="#059669">You are <strong>not allowed to study.</strong> Maximum: one or two rapid UWorld blocks.</Bullet>
          <Bullet dot="#059669">Spend time with loved ones. Go out. Watch a movie. Destress.</Bullet>
          <Bullet dot="#059669">Prepare your meal(s) for exam day.</Bullet>
          <Bullet dot="#059669"><strong>Sleep early.</strong> Your sleep schedule now determines your alertness tomorrow.</Bullet>
        </Card>
        <Card color="#E05252" delay={280}>
          <div style={{fontSize:14,fontWeight:800,color:"#0A0F1E",marginBottom:6}}>At the Exam Center — Entry procedure</div>
          <Bullet>Sign in, personal belongings checked by security guard.</Bullet>
          <Bullet>Metal detector scan, turn out pockets, show ankles/socks, ID check.</Bullet>
          <Bullet>Glasses wearers: remove glasses and show all dimensions to check for mics/cameras.</Bullet>
          <Bullet>This ritual happens <strong>every time you enter</strong> the exam room (not exit).</Bullet>
          <Bullet>First entry: registered into system. Given <strong>2 scratch cards + 2 markers.</strong> Check if markers work.</Bullet>
          <Bullet>Lockers available for bag and phone. Transparent water bottle allowed inside.</Bullet>
        </Card>
        <Card color="#2563EB" delay={440}>
          <div style={{fontSize:14,fontWeight:800,color:"#0A0F1E",marginBottom:6}}>Inside — Equipment & start time</div>
          <Bullet>Equipment: monitor, keyboard, mouse, over-ear headphones, earmuffs.</Bullet>
          <Bullet>Test all equipment before starting. Raise concerns with the invigilator — they're there to help.</Bullet>
          <Bullet>Exam does not start at 9 AM sharp — you can start earlier or later. Some start at 9:25 AM. You get your full 8 hours regardless.</Bullet>
        </Card>
      </div>
    </Slide>
  );
}

function S20_ExamDayTips() {
  const breaks = ["5 min","5 min","10 min","10 min","20 min","10 min"];
  return (
    <Slide>
      <Tag color="#E05252">Exam Day</Tag>
      <H>Inside the exam —<br/><span style={{color:"#E05252"}}>tips & break strategy.</span></H>
      <Div color="#E05252"/>
      <A delay={160}>
        <div style={{background:"#fff",borderRadius:13,padding:"13px 15px",
          border:"1px solid rgba(220,38,38,.15)",borderTop:"3px solid #E05252",
          boxShadow:"0 2px 10px rgba(0,0,0,.05)",marginBottom:14}}>
          <div style={{fontSize:14,fontWeight:800,color:"#0A0F1E",marginBottom:7}}>During the exam</div>
          <Bullet><strong>Sit up straight.</strong> You'll be seated for hours — bad posture causes backache.</Bullet>
          <Bullet><strong>Skip the tutorial.</strong> This saves 15 minutes — added directly to your total break time.</Bullet>
          <Bullet>Take a break after <strong>every block.</strong> Hydrate. Use the facilities.</Bullet>
          <Bullet>If you finish a block early, the remaining time is <strong>added to your break time.</strong></Bullet>
          <Bullet>Use your own question-solving strategy — continue relying on what worked during prep.</Bullet>
        </div>
      </A>
      <A delay={300}><div style={{fontSize:10,fontWeight:700,letterSpacing:"2px",textTransform:"uppercase",color:"#9CA3AF",marginBottom:8}}>Recommended Break Distribution (1 hour total)</div></A>
      <A delay={340}>
        <div style={{display:"flex",gap:6,marginBottom:14,flexWrap:"wrap"}}>
          {breaks.map((b,i)=>(
            <div key={i} style={{flex:1,minWidth:50,background:"#fff",borderRadius:10,padding:"10px 8px",
              border:"1px solid #E5EAF0",textAlign:"center",boxShadow:"0 1px 6px rgba(0,0,0,.04)"}}>
              <div style={{fontSize:10,color:"#9CA3AF",marginBottom:3}}>Break {i+1}</div>
              <div style={{fontFamily:"'Playfair Display',serif",fontSize:15,fontWeight:900,
                color:i===4?"#E05252":"#0A0F1E"}}>{b}</div>
            </div>
          ))}
        </div>
      </A>
      <A delay={500}>
        <div style={{background:`linear-gradient(135deg,${NAVY},#0D1530)`,borderRadius:14,padding:"16px 18px"}}>
          <div style={{fontFamily:"'Playfair Display',serif",fontSize:15,fontWeight:700,
            color:GOLD,marginBottom:6,fontStyle:"italic"}}>"You've been studying hard for months. You have done just about everything you could've done. Now is the moment of truth."</div>
          <div style={{fontSize:13,color:"rgba(255,255,255,.4)",marginBottom:10}}>Trust yourself. Trust your preparation.</div>
          <div style={{fontSize:14,color:"rgba(255,255,255,.65)",lineHeight:1.65}}>
            Once your exam is done, let the invigilator know. They will hand you a document confirming completion. Then: <strong style={{color:GOLD}}>rest up and party hard. You deserve it.</strong>
          </div>
        </div>
      </A>
    </Slide>
  );
}

function S21_FAQ() {
  const faqs = [
    {q:"How do I balance Step 1 & medical school?",a:"Plan your timeline so overlap between your Step 1 syllabus and university syllabus is as large as possible. Even 3–4 hours/day consistently during the non-dedicated phase will keep you well prepared."},
    {q:"How much does the USMLE journey cost?",a:"The entire match process can cost around $25,000 — exams, electives, ERAS application. Have a conversation with your sponsor early and plan finances accordingly."},
    {q:"How far in advance should I register?",a:"Begin registration at least 6–8 months before your intended exam date. The process takes 1–2 months. Seats typically open 6 months prior."},
    {q:"When should I start preparation?",a:"True Step 1 preparation should start from mid-2nd year onwards. Before that, focus on university syllabus, friends, experiences, and co-curricular activities."},
    {q:"How to start preparation?",a:"Cover content your university is currently teaching (if it overlaps with Step 1). Use the resource of your choice. Once you've covered a large portion of the syllabus, begin UWorld."},
    {q:"I already graduated — is it too late?",a:"Never too late. While ideal to take during med school, many start post-graduation and successfully match into their preferred specialty. If you're passionate and willing to work — go for it."},
    {q:"What if I keep forgetting stuff from First Aid?",a:"Totally normal. The syllabus is huge. Keep doing blocks and trust the process. Incorporate active recall (Anki, questions). Don't spend too much time passively reading."},
    {q:"How many passes of First Aid should I do?",a:"Don't count passes. Use First Aid as a content outline to refer to throughout your prep — not a book to read cover to cover."},
    {q:"Should I do a second pass of UWorld?",a:"Not recommended. It's better to redo incorrects + marked questions + targeted weak blocks. The goal isn't to memorize UWorld — it's to learn how to approach questions you've never seen before."},
    {q:"Should I annotate everything from UWorld onto First Aid?",a:"Definitely not everything. Annotating is time-consuming and those notes often go unreviewed. Be very selective — stick to 1–2 key points per question maximum."},
    {q:"How many hours should I study?",a:"No right answer. Quality > quantity. What you do during those hours matters more than the count. Build a routine and stay consistent. Don't compare your timeline with peers — everyone's pace is different."},
  ];
  const [open,setOpen]=useState(null);
  return (
    <Slide>
      <Tag color="#2563EB">FAQ</Tag>
      <H>Frequently asked<br/><span style={{color:"#2563EB"}}>questions.</span></H>
      <Div color="#2563EB"/>
      <div style={{display:"flex",flexDirection:"column",gap:6,flex:1,overflow:"auto"}}>
        {faqs.map((f,i)=>(
          <A key={i} delay={80+i*40} dir="right">
            <div style={{background:"#fff",borderRadius:10,border:"1px solid #E5EAF0",
              boxShadow:"0 1px 5px rgba(0,0,0,.04)",overflow:"hidden"}}>
              <button onClick={()=>setOpen(open===i?null:i)}
                style={{width:"100%",display:"flex",justifyContent:"space-between",alignItems:"flex-start",
                  padding:"10px 13px",background:"none",border:"none",cursor:"pointer",
                  textAlign:"left",fontFamily:"inherit",gap:8}}>
                <span style={{fontSize:14,fontWeight:700,color:"#0A0F1E",lineHeight:1.4,flex:1}}>{f.q}</span>
                <span style={{fontSize:15,color:"#9CA3AF",flexShrink:0,transform:open===i?"rotate(180deg)":"none",transition:"transform .2s"}}>{open===i?"▲":"▼"}</span>
              </button>
              {open===i&&(
                <div style={{padding:"0 13px 11px",fontSize:13,color:"#6B7280",lineHeight:1.65,borderTop:"1px solid #F1F5F9",paddingTop:8}}>
                  {f.a}
                </div>
              )}
            </div>
          </A>
        ))}
      </div>
    </Slide>
  );
}

function S22_Abbreviations() {
  const abbrs = [
    ["USMLE","United States Medical Licensing Examination","A three-step examination for medical licensure in the US — assesses a physician's ability to apply knowledge, concepts, and principles important in health and disease."],
    ["ECFMG","Educational Commission for Foreign Medical Graduates","Assesses whether IMGs are ready to enter residency or fellowship programs in the US accredited by ACGME."],
    ["FSMB","Federation of State Medical Boards","Represents 70 state medical and osteopathic regulatory boards and co-sponsors the USMLE with the NBME."],
    ["NRMP","National Resident Matching Program","A private, non-profit organization that matches medical school students and graduates to residency programs in the US through a uniform system."],
    ["ERAS","Electronic Residency Application Service","Transmits residency applications, letters of recommendation, MSPEs, transcripts, and other credentials from applicants and schools to program directors."],
    ["OET","Occupational English Test","An international English language test assessing communication skills of healthcare professionals seeking to register and practice in English-speaking environments."],
    ["ACGME","Accreditation Council for Graduate Medical Education","Responsible for accrediting the majority of graduate medical training programs for physicians in the United States."],
    ["AAMC","Association of American Medical Colleges","A not-for-profit association dedicated to transforming health care through innovative medical education, cutting-edge patient care, and groundbreaking research."],
  ];
  return (
    <Slide>
      <Tag color="#6B7280">Reference</Tag>
      <H>Important<br/><span style={{color:"#6B7280"}}>abbreviations.</span></H>
      <Div color="#6B7280"/>
      <div style={{display:"flex",flexDirection:"column",gap:6,flex:1,overflow:"auto"}}>
        {abbrs.map(([a,f,d],i)=>(
          <A key={i} delay={60+i*50} dir="right">
            <div style={{display:"flex",gap:10,alignItems:"flex-start",background:"#fff",
              borderRadius:10,padding:"9px 12px",border:"1px solid #E5EAF0",
              boxShadow:"0 1px 5px rgba(0,0,0,.04)"}}>
              <div style={{fontFamily:"'Playfair Display',serif",fontSize:16,fontWeight:900,
                color:NAVY,width:52,flexShrink:0,lineHeight:1.2}}>{a}</div>
              <div>
                <div style={{fontSize:13,fontWeight:700,color:"#0A0F1E",marginBottom:2}}>{f}</div>
                <div style={{fontSize:12,color:"#9CA3AF",lineHeight:1.5}}>{d}</div>
              </div>
            </div>
          </A>
        ))}
      </div>
    </Slide>
  );
}

function S23_Closing() {
  const steps = [
    {n:"01",title:"Set up your resources",desc:"Get UWorld, First Aid 2025, and your video resource of choice sorted today.",color:"#2563EB"},
    {n:"02",title:"Join the WhatsApp group",desc:"All daily updates, QIDs, and mentor check-ins happen there.",color:"#059669"},
    {n:"03",title:"Log into the LMS",desc:"Your Day 1 schedule is already built. Open it, read it, follow it.",color:GOLD},
    {n:"04",title:"Show up on June 1st",desc:"Day 1 of your 120-day journey begins. Your study plan is ready — trust the process.",color:"#E05252"},
  ];
  return (
    <div style={{minHeight:"100vh",background:`linear-gradient(160deg,${NAVY} 0%,#080E20 55%,#0D1530 100%)`,
      display:"flex",flexDirection:"column",position:"relative",overflow:"hidden"}}>
      <div style={{position:"absolute",inset:0,backgroundImage:`radial-gradient(rgba(201,168,76,.06) 1px,transparent 1px)`,backgroundSize:"26px 26px",pointerEvents:"none"}}/>
      <div style={{position:"absolute",bottom:-80,left:-60,width:360,height:360,borderRadius:"50%",
        background:`radial-gradient(circle,rgba(37,99,235,.08) 0%,transparent 65%)`,pointerEvents:"none"}}/>

      <div style={{padding:"26px 26px 0",position:"relative",zIndex:1}}>
        <A delay={60}><div style={{fontSize:10,fontWeight:700,letterSpacing:"2.5px",textTransform:"uppercase",color:GOLD,opacity:.8,marginBottom:12}}>You are here. Let's get to work.</div></A>
        <A delay={120}><div style={{fontFamily:"'Playfair Display',serif",fontSize:"clamp(24px,5.5vw,36px)",fontWeight:900,lineHeight:1.05,letterSpacing:"-1.2px",color:"#fff",marginBottom:10}}>Your next<br/><span style={{fontStyle:"italic",color:GOLD}}>4 steps.</span></div></A>
        <A delay={200}><div style={{width:26,height:2.5,background:GOLD,borderRadius:2,marginBottom:18}}/></A>
      </div>

      <div style={{flex:1,padding:"0 26px",display:"flex",flexDirection:"column",gap:10,position:"relative",zIndex:1}}>
        {steps.map((s,i)=>(
          <A key={i} delay={260+i*100} dir="right">
            <div style={{background:"rgba(255,255,255,.05)",border:"1px solid rgba(255,255,255,.08)",
              borderLeft:`3px solid ${s.color}`,borderRadius:11,padding:"13px 15px",
              display:"flex",gap:12,alignItems:"flex-start"}}>
              <div style={{fontFamily:"'Playfair Display',serif",fontSize:14,fontWeight:900,
                color:s.color,opacity:.45,flexShrink:0,width:20}}>{s.n}</div>
              <div>
                <div style={{fontSize:15,fontWeight:800,color:"#fff",marginBottom:3}}>{s.title}</div>
                <div style={{fontSize:13,color:"rgba(255,255,255,.42)",lineHeight:1.6}}>{s.desc}</div>
              </div>
            </div>
          </A>
        ))}
      </div>

      <div style={{padding:"20px 26px",position:"relative",zIndex:1}}>
        <A delay={700}>
          <div style={{background:"rgba(201,168,76,.08)",border:"1px solid rgba(201,168,76,.22)",
            borderRadius:12,padding:"14px 18px",textAlign:"center",marginBottom:12}}>
            <div style={{fontFamily:"'Playfair Display',serif",fontSize:17,fontWeight:700,
              color:"#fff",marginBottom:4,fontStyle:"italic",lineHeight:1.4}}>
              "Trust yourself, trust your preparation, and go get them!"
            </div>
            <div style={{fontSize:12,color:"rgba(255,255,255,.3)"}}>Dr. Ali · USMLE Corner · Batch June 2025</div>
          </div>
        </A>
        <A delay={820}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span style={{fontSize:10,color:"rgba(255,255,255,.2)",letterSpacing:"1px"}}>lms.usmlecorner.com</span>
            <span style={{fontSize:10,color:"rgba(255,255,255,.2)"}}>Batch June 2025 · USMLE Corner</span>
          </div>
        </A>
      </div>
    </div>
  );
}

/* == NAVIGATION == */
const SLIDES=[
  {id:"cover",        label:"Welcome",          C:S01_Cover},
  {id:"agenda",       label:"Agenda",           C:S00_Agenda},
  {id:"team",         label:"Our Team",         C:S01b_Team},
  {id:"usmle",        label:"What is USMLE",    C:S02_WhatIsUSMLE},
  {id:"step1",        label:"What is Step 1",   C:S03_WhatIsStep1},
  {id:"when",         label:"When & How Long",  C:S04_WhenAndHowLong},
  {id:"approaches",   label:"Study Approaches", C:S05_StudyApproaches},
  {id:"registration", label:"Registration",     C:S06_Registration},
  {id:"resources",    label:"Resources",        C:S07_Resources},
  {id:"youtube",      label:"YT/Anki/Extra",    C:S08_YouTube_Anki},
  {id:"modes",        label:"UWorld Modes",     C:S09_UWorldModes},
  {id:"system",       label:"System vs Random", C:S10_UWorldSystem},
  {id:"solving",      label:"Q Solving",        C:S11_QuestionSolving},
  {id:"reviewing",    label:"Reviewing Qs",     C:S12_ReviewingQuestions},
  {id:"whywrong",     label:"3 Reasons Wrong",  C:S13_WhyWrong},
  {id:"assessments",  label:"Self-Assessments", C:S14_SelfAssessments},
  {id:"8hour",        label:"8-Hour Sim",       C:S15_EightHourSim},
  {id:"dedicated",    label:"Dedicated Period", C:S17_DedicatedPeriod},
  {id:"twodaysbefore",label:"2 Days Before",    C:S18_TwoDaysBefore},
  {id:"daybefore",    label:"Day Before",       C:S19_DayBeforeAndExamDay},
  {id:"examday",      label:"Exam Day Tips",    C:S20_ExamDayTips},
  {id:"faq",          label:"FAQ",              C:S21_FAQ},
  {id:"abbr",         label:"Abbreviations",    C:S22_Abbreviations},
  {id:"closing",      label:"Closing",          C:S23_Closing},
];

export default function App(){
  const [idx,setIdx]=useState(0);
  const [k,setK]=useState(0);
  const go=n=>{const nx=Math.max(0,Math.min(SLIDES.length-1,n));if(nx===idx)return;setIdx(nx);setK(p=>p+1);};
  useEffect(()=>{
    const fn=e=>{if(e.key==="ArrowRight"||e.key==="ArrowDown")go(idx+1);if(e.key==="ArrowLeft"||e.key==="ArrowUp")go(idx-1);};
    window.addEventListener("keydown",fn);return()=>window.removeEventListener("keydown",fn);
  },[idx]);
  const C=SLIDES[idx].C;
  return(
    <>
      <G/>
      <div style={{height:"100vh",overflow:"hidden",position:"relative"}}>
        <div key={k} style={{height:"100%",overflow:"auto"}}><C/></div>

        <div style={{position:"fixed",top:10,left:"50%",transform:"translateX(-50%)",
          display:"flex",gap:3,zIndex:100,background:"rgba(255,255,255,.88)",
          backdropFilter:"blur(8px)",borderRadius:99,padding:"5px 10px",
          boxShadow:"0 2px 10px rgba(0,0,0,.1)"}}>
          {SLIDES.map((s,i)=>(
            <button key={i} onClick={()=>go(i)} title={s.label}
              style={{width:i===idx?18:5,height:5,borderRadius:99,
                background:i===idx?GOLD:"rgba(0,0,0,.15)",border:"none",cursor:"pointer",padding:0,
                transition:"all .22s cubic-bezier(0.23,1,0.32,1)"}}/>
          ))}
        </div>

        <div style={{position:"fixed",top:30,left:"50%",transform:"translateX(-50%)",
          fontSize:10,color:"#9CA3AF",fontWeight:600,letterSpacing:"1px",zIndex:100,whiteSpace:"nowrap"}}>
          {SLIDES[idx].label}
        </div>

        {idx>0&&<button onClick={()=>go(idx-1)}
          style={{position:"fixed",bottom:22,left:18,zIndex:100,width:36,height:36,borderRadius:"50%",
            background:"rgba(255,255,255,.9)",backdropFilter:"blur(8px)",
            border:"1px solid rgba(0,0,0,.1)",cursor:"pointer",fontSize:17,
            display:"flex",alignItems:"center",justifyContent:"center",
            boxShadow:"0 2px 10px rgba(0,0,0,.1)"}}>&#8592;</button>}

        {idx<SLIDES.length-1&&<button onClick={()=>go(idx+1)}
          style={{position:"fixed",bottom:22,right:18,zIndex:100,width:40,height:40,borderRadius:"50%",
            background:`linear-gradient(135deg,${GOLD},#A8862E)`,border:"none",cursor:"pointer",
            fontSize:17,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",
            boxShadow:"0 4px 14px rgba(201,168,76,.45)"}}>&#8594;</button>}

        <div style={{position:"fixed",bottom:28,left:"50%",transform:"translateX(-50%)",
          fontSize:10,color:"rgba(0,0,0,.22)",letterSpacing:"1.5px",fontWeight:600,zIndex:100}}>
          {idx+1} / {SLIDES.length}
        </div>
      </div>
    </>
  );
}
